import { Box, Stack, styled } from "@mui/material";
import pxToRem from "theme/base/pxToRem";

export const Tabs = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  gap: pxToRem(16),
  margin: `${pxToRem(20)} ${pxToRem(16)}`,
}));

export const Tab = styled(Box)<{ active?: boolean }>(({ theme, active }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: `${pxToRem(10)} ${pxToRem(16)}`,
  backgroundColor: active
    ? theme.palette.background.bgBrandPrimary
    : theme.palette.background.bgTertiary,
  color: active
    ? theme.palette.text.textLink
    : theme.palette.text.textSecondary,
  borderRadius: pxToRem(8),
  textAlign: "center",
  cursor: "pointer",
}));

export const TabContent = styled(Box)(({ theme }) => ({
  overflow: "scroll",
  flex: 1,
  height: "100%",
  margin: `0 ${pxToRem(16)}`,
  table: {
    thead: {
      th: {
        div: {
          justifyContent: "right",
        },
      },
    },
    tbody: {
      tr: {
        td: {
          width: "100%",
          textAlign: "right",
          justifyContent: "flex-end",
        },
      },
    },
  },
}));
